// Chakra imports
import { Box, Text, useColorModeValue, IconButton, useToast } from "@chakra-ui/react";
import { PrintIcon } from "@chakra-ui/icons";
import { FaPrint } from "react-icons/fa"; // Importar el icono de impresora de FontAwesome
import Card from "components/card/Card.js";
import React from "react";

export default function Download({ title, bufferData, fileName = "documento.pdf", ...rest }) {
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const bg = useColorModeValue("white", "navy.700");

  const toast = useToast();

  // Función para abrir el PDF en una nueva pestaña para impresión
  const handleOpenPdf = () => {
    if (!bufferData || !bufferData.data || bufferData.data.length === 0) {
      toast({
        title: "Error",
        description: "El documento no está disponible.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      // Convertir Buffer a Uint8Array
      const pdfData = new Uint8Array(bufferData.data);

      // Crear un Blob con el tipo correcto
      const blob = new Blob([pdfData], { type: "application/pdf" });

      // Generar una URL temporal
      const url = URL.createObjectURL(blob);

      // Abrir en nueva pestaña
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        // Esperar un poco y luego imprimir automáticamente
        setTimeout(() => {
          newWindow.print();
        }, 1000);
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "No se pudo abrir el documento.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      console.error("Error al procesar el archivo:", error);
    }
  };

  return (
    <Card bg={bg} p={4} display="flex" flexDirection="row" alignItems="center" justifyContent="space-between" {...rest}>
      <Box>
        <Text fontWeight="500" color={textColorSecondary} fontSize="sm">
          {title}
        </Text>
        <Text color={textColorPrimary} fontWeight="500" fontSize="md">
          {fileName}
        </Text>
      </Box>
      {bufferData && bufferData.data?.length > 0 && (
        <IconButton
          aria-label="Imprimir archivo"
          icon={<FaPrint />} // Aquí se usa el icono de impresora
          colorScheme="blue"
          onClick={handleOpenPdf}
        />
      )}
    </Card>
  );
}
